import {
  AccordionContainer,
  AccordionContent,
  AccordionTitle,
} from './styled.accordion';
import { DropdownIcon } from './../../../common/icons/DropdownIcon';
import React, { useRef, useState } from 'react';

export function Accordion ({ accordion, children }) {
  const content = useRef<HTMLDivElement>();

  const [open, setOpen] = useState<boolean>(false);
  const [height, setHeight] = useState<string>('0px');

  function toggleAccordion () {
    setOpen(!open);
    if (content && content.current) {
      setHeight(open ? '0px' : `${content.current.scrollHeight}px`);
    }
  }

  return (
    <>
      <AccordionContainer onClick={toggleAccordion}>
        <AccordionTitle>{accordion.title}</AccordionTitle>
        <AccordionTitle>
          <DropdownIcon color={'verdigrisDark'} rotate={open ? '180' : '0'} />
        </AccordionTitle>
      </AccordionContainer>
      <AccordionContent ref={content} height={height}>
        {children}
      </AccordionContent>
    </>
  );
}
